import { render, staticRenderFns } from "./CommentsPage.vue?vue&type=template&id=7fcf9a86&scoped=true&"
import script from "./CommentsPage.vue?vue&type=script&lang=js&"
export * from "./CommentsPage.vue?vue&type=script&lang=js&"
import style0 from "./CommentsPage.vue?vue&type=style&index=0&id=7fcf9a86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcf9a86",
  null
  
)

export default component.exports